import { render, staticRenderFns } from "./knowdetail.vue?vue&type=template&id=4638b03e"
import script from "./knowdetail.vue?vue&type=script&lang=js"
export * from "./knowdetail.vue?vue&type=script&lang=js"
import style0 from "./knowdetail.vue?vue&type=style&index=0&id=4638b03e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports